module.exports = __webpack_public_path__ + "img/main-banner-blurred.eb19e492.png";